module.exports = __webpack_public_path__ + "img/assign.d2086bc5.svg";